import { render, staticRenderFns } from "./ModificarExamenes.vue?vue&type=template&id=709cfc36&scoped=true&"
import script from "./ModificarExamenes.vue?vue&type=script&lang=js&"
export * from "./ModificarExamenes.vue?vue&type=script&lang=js&"
import style0 from "./ModificarExamenes.vue?vue&type=style&index=0&id=709cfc36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cfc36",
  null
  
)

export default component.exports